import React, { useRef, useEffect } from "react";

const CalendarPopup = ({
  event,
  onAddToAppleOutlook,
  getGoogleCalendarURL,
  onClose,
}) => {
  const menuRef = useRef(null);

  useEffect(() => {
    // Cerrar el menú al hacer clic fuera de él
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const menuStyles = {
    position: "absolute",
    bottom: "100%",
    right: "0",
    width: "250px",
    background: "white",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    zIndex: "10",
    marginBottom: "10px",
  };

  const titleStyles = {
    background: "#f2f2f2",
    padding: "12px 16px",
    fontWeight: "600",
    borderBottom: "1px solid #eaeaea",
  };

  const buttonStyles = {
    display: "block",
    width: "100%",
    padding: "12px 16px",
    textAlign: "left",
    background: "none",
    border: "none",
    fontSize: "14px",
    cursor: "pointer",
  };

  const linkStyles = {
    ...buttonStyles,
    textDecoration: "none",
    color: "inherit",
  };

  return (
    <div style={menuStyles} ref={menuRef}>
      <div style={titleStyles}>Afegir al calendari</div>
      <div>
        <button style={buttonStyles} onClick={() => onAddToAppleOutlook(event)}>
          Apple Calendar / Outlook
        </button>
        <a
          href={getGoogleCalendarURL(event)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClose}
          style={linkStyles}
        >
          Google Calendar
        </a>
      </div>
    </div>
  );
};

export default CalendarPopup;
